/* __next_internal_client_entry_do_not_use__ default auto */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from "react";
import "./csrMain.css";
export default param => {
  let {
    transformHtml
  } = param;
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const containerRef = useRef(null);
  useEffect(() => {
    let observer = null;
    // 延迟渲染HTML内容以不影响LCP
    const deferredRender = () => {
      setShouldRender(true);
      // 使用Intersection Observer检测元素是否在视口中
      if (containerRef.current && "IntersectionObserver" in window) {
        observer = new IntersectionObserver(entries => {
          const [entry] = entries;
          if (entry.isIntersecting) {
            // 元素进入视口时再渲染内容
            if (window.requestIdleCallback) {
              window.requestIdleCallback(() => {
                setIsContentLoaded(true);
              }, {
                timeout: 1000
              });
            } else {
              setTimeout(() => {
                setIsContentLoaded(true);
              }, 50);
            }
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
          }
        }, {
          rootMargin: "50px",
          threshold: 0.1
        });
        observer.observe(containerRef.current);
      } else {
        // 降级方案：直接使用requestIdleCallback
        if (window.requestIdleCallback) {
          window.requestIdleCallback(() => {
            setIsContentLoaded(true);
          }, {
            timeout: 2000
          });
        } else {
          setTimeout(() => {
            setIsContentLoaded(true);
          }, 100);
        }
      }
    };
    // 检查页面是否已经加载完成
    if (document.readyState === "complete") {
      deferredRender();
    } else {
      // 等待页面加载完成后再渲染
      window.addEventListener("load", deferredRender);
      return () => {
        window.removeEventListener("load", deferredRender);
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
      };
    }
    return () => {
      observer === null || observer === void 0 ? void 0 : observer.disconnect();
    };
  }, []);
  // 在内容加载前显示占位符
  if (!shouldRender) {
    return /*#__PURE__*/_jsx("div", {
      className: "article-tml article-tml-loading",
      id: "tml",
      ref: containerRef,
      style: {
        minHeight: "200px"
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "loading-placeholder",
        children: [/*#__PURE__*/_jsx("div", {
          className: "loading-skeleton"
        }), /*#__PURE__*/_jsx("div", {
          className: "loading-skeleton"
        }), /*#__PURE__*/_jsx("div", {
          className: "loading-skeleton"
        })]
      })
    });
  }
  // 根据加载状态返回不同的渲染内容
  if (isContentLoaded) {
    return /*#__PURE__*/_jsx("div", {
      className: "article-tml article-tml-loaded",
      id: "tml",
      ref: containerRef,
      dangerouslySetInnerHTML: {
        __html: transformHtml
      }
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: "article-tml article-tml-loading",
    id: "tml",
    ref: containerRef,
    style: {
      minHeight: "200px"
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: "loading-placeholder",
      children: [/*#__PURE__*/_jsx("div", {
        className: "loading-skeleton"
      }), /*#__PURE__*/_jsx("div", {
        className: "loading-skeleton"
      }), /*#__PURE__*/_jsx("div", {
        className: "loading-skeleton"
      })]
    })
  });
};